module.exports = __webpack_public_path__ + "static/img/13_3.ad6d46b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/13_3.png
// module id = 3qCi
// module chunks = 0